<template>
  <div>
    <top-bar :user="this.user" />
    <MenuItems :user="this.user" :menuSelected="{ friends: true }" />
    <div class="menu-mobile">
      <div class="user-mobile">
        <div class="close-menu" @click="openMenu(false)">
          <img src="@/assets/images/x.svg" />
        </div>
        <div class="openNotifications" @click="showModalPopup('modal_popup_mobileNotifications', true)">
          <div class="unread-notifications">
            <span>2</span>
          </div>
          <img src="@/assets/images/clopotel-alb.svg" />
        </div>

        <div id="modal_popup_mobileNotifications" class="modal-popup">
          <div class="modal-popup-content">
            <a @click="showModalPopup('modal_popup_mobileNotifications', false)" class="close-button">
              <img src="@/assets/images/close-button.svg" />
            </a>
            <div class="notifications">
              <!-- <NotificationsBox :notifications="this.companyMessages" /> -->
            </div>
          </div>
        </div>

        <div>
          <img src="@/assets/images/linie.png" />
        </div>
        <div>
          <img src="@/assets/images/settings.png" />
        </div>
        <div>
          <!-- <a href="#">{{ this.customer.name | titleCase }}</a> -->
        </div>
      </div>
      <MenuItems :user="this.user" :menuSelected="{ friends: true }" />
    </div>
    <div class="container-right">
      <div :class="{
        content: true,
        'dashboard-beneficiary': true,
      }">
        <div v-if="this.selectedPerson">
          <h3 class="return">
            <a href="#" @click="selectedPerson = null">
              <font-awesome-icon icon="chevron-left" />
              <span>{{ $t("backButtonLabel") }}</span>
            </a>
          </h3>
          <person-details :person="this.selectedPerson" :isFriend="isFriend(this.selectedPerson.id)" :user="this.user" />
        </div>
        <div v-else>
          <h1>{{ $t("friendsTitle") }}</h1>
          <p>{{ $t("friendsShortDesc") }}</p>
          <br />

          <div>
            <img class="square-50 border-round" v-for="(entry, index) in friends" :key="index"
              :src="getImagePath() + 'users/user_' + entry.id + '.png'"
              @error="($event.target.src = require('@/assets/images/offer_0.svg'))" @click="selectPerson(entry)" />
          </div>
          <div>
            <h3>{{ $t("browsePersonsLabel") }}</h3>
            <div class="persons-content">
              <friend-case v-for="(entry, index) in persons" :key="index" :person="entry" @addFriend="addFriend"
                :isFriend="isFriend(entry.id)" @selectPerson="selectPerson" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="modal_popup_info" class="modal-popup">
      <div class="modal-popup-content">
        <a @click="showModalPopup('modal_popup_info', false)" class="close-button">
          <img src="@/assets/images/close-button.svg" />
        </a>
        <div v-if="this.personsError">
          <br />
          <p v-html="$t('error_' + this.personsError.code)"></p>
        </div>
        <div v-else>
          <p>{{ $t("addNewFriendSuccess") }}</p>
        </div>
      </div>
    </div>
    <!-- <modal-loading /> -->
  </div>
</template>

<script>
import Cookies from "js-cookie";
import TopBar from "../components/company/TopBar.vue";
import MenuItems from "../components/company/MenuItems.vue";
import FriendCase from "../components/fragments/FriendCase.vue";
import PersonDetails from "@/components/company/PersonDetails.vue";
import httpServiceCustomer from "@/http/http-customer.js";
import ModalLoading from "@/components/fragments/ModalLoading.vue";

export default {
  name: "Friends",
  components: { TopBar, MenuItems, FriendCase, PersonDetails, ModalLoading },
  data() {
    return {
      user: null,
      friends: null,
      persons: null,
      selectedPerson: null,
      perPage: 10000,
      currentPage: 1,
      sortField: "lname",
      sortDirection: "asc",
      personsError: null,
    };
  },
  methods: {
    getPersons(isFriend) {
      if (isFriend) {
        this.friends = null;
      } else {
        this.persons = null;
      }
      // var persons = "?type=" + this.offerType;
      var persons =
        "?per_page=" +
        this.perPage +
        "&page=" +
        this.currentPage +
        "&sort=" +
        this.sortDirection;
      if (isFriend) {
        persons += "&friend=Y";
      }
      if (this.sortDirection === "desc") {
        persons += "&desc=" + this.sortField;
      } else {
        persons += "&asc=" + this.sortField;
      }
      httpServiceCustomer.customerService
        .searchPersons(persons, Cookies.get("token"))
        .then(function (response) {
          return response;
        })
        .catch((error) => {
          this.personsError = {
            code: error.response.data,
            description: "Error fetching persons",
          };
        })
        .then((response) => {
          if (response.status == 200) {
            if (isFriend) {
              this.friends = response.data;
            } else {
              this.persons = response.data;
            }
            // this.invoicesCount = response.headers["x-up-count"]; //["Content-Length"];
          } else if (response.status == 400 || response.status == 403) {
            this.personsError = {
              code: response.data,
              description: "Error fetching persons",
            };
          } else {
            this.personsError = { description: response.description };
          }
        });
    },
    isFriend(personId) {
      var arrR = this.friends.filter(function (ele) {
        return (ele.id == personId)
      });
      return arrR.length > 0;
    },
    selectPerson(person) {
      this.selectedPerson = person;
    },
    addFriend(personId) {
      // this.personsError = {
      //   code: "NOT_IMPLEMENTED",
      // };
      // this.showModalPopup("modal_popup_loading", true);
      this.personsError = null;
      httpServiceCustomer.customerService
        .addFriend(this.user.id, { id: personId }, Cookies.get("token"))
        .then(function (response) {
          return response;
        })
        .catch((error) => {
          return error.response;
          // this.personsError = { code: error.response.code };
          // // this.showModalPopup("modal_popup_loading", false);
          // this.showModalPopup("modal_popup_info", true);
        })
        .then((response) => {
          if (response.status == 200) {
            this.getPersons(true);
          } else if (response.status == 409) {
            this.personsError = {
              code: 'FRIEND_ALREADY',
              description: "Error adding offer",
            };
          } else {
            this.personsError = {
              code: response.data.code,
              description: "Error adding offer",
            };
          }
          // this.showModalPopup("modal_popup_loading", false);
          this.showModalPopup("modal_popup_info", true);
        });
    },
  },
  mounted() {
    this.getPersons(false);
    this.getPersons(true);
    // this.selectedOfferId = 0;

    // this.openOfferDetails(15);
  },
  created() {
    this.user = this.getUser();
  }
};
</script>
<style scoped src="@/assets/styles/beneficiary.css">

</style>
<style scoped>
.persons-content {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
}
</style>
